module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>edit_view_edit_columns</title><path d=M264.46,956.61H61.55V689.85H376.89l87.77-86.7V63.93A59.55,59.55,0,0,0,405.11,4.38H2V956.61a59.55,59.55,0,0,0,59.55,59.55H253.73ZM61.55,63.93H405.11V331.8H61.55Zm0,327.25H405.11V630.47H61.55Z /><rect x=595.39 y=332.46 width=260.7 height=577.23 transform=\"translate(799.76 1573.42) rotate(-135)\"/><polygon points=\"372.33 790.15 327.2 1019.62 556.67 974.49 372.33 790.15\"/></svg>";


//////////////////
// WEBPACK FOOTER
// ../~/html-loader!../~/@printos/gazelle/src/extensions/grid/images/grid-columns.svg
// module id = 157
// module chunks = 0